import { ThankYou } from './thank-you-section';

export default function RegisterThankYou() {
  return <ThankYou />;
}
